import React, { Component } from "react";
import { Link } from "react-router-dom";
import "../../src/styles/login.scss";
import axios from "axios";
import LoginNavbar from "./loginNavbar";
import { apiHost } from "../api/apiClient";
import { Helmet } from "react-helmet";
import visionTrakLogo from "../Assets/visiontrak-logo-colored.png";

class ResetPassword extends Component {
  constructor(props) {
    super(props);
    const query = new URLSearchParams(props.location.search);
    const resetToken = query.get("token")
      || query.get("amp;token")
      || query.get("amp;amp;token")
      || "";
    this.state = {
      email: (query.get("email") || "").trim(),
      token: resetToken.replace(/ /g, "+"),
      newPassword: "",
      confirmPassword: "",
      passwordError: "",
      confirmPasswordError: "",
      submitMessage: "",
      submitError: "",
      submitting: false,
    };
  }

  handleNewPassword = (evt) => {
    this.setState({
      newPassword: evt.target.value,
      passwordError: "",
      submitMessage: "",
      submitError: "",
    });
  };

  handleConfirmPassword = (evt) => {
    this.setState({
      confirmPassword: evt.target.value,
      confirmPasswordError: "",
      submitMessage: "",
      submitError: "",
    });
  };

  validate = () => {
    let valid = true;

    if (!this.state.newPassword || this.state.newPassword.length < 6 || this.state.newPassword.length > 20) {
      this.setState({ passwordError: "Password must be between 6 and 20 characters." });
      valid = false;
    }

    if (this.state.newPassword !== this.state.confirmPassword) {
      this.setState({ confirmPasswordError: "Passwords do not match." });
      valid = false;
    }

    return valid;
  };

  handleSubmit = async (evt) => {
    evt.preventDefault();

    if (!this.state.email || !this.state.token) {
      this.setState({ submitError: "This password reset link is invalid or expired." });
      return;
    }

    if (!this.validate()) {
      return;
    }

    this.setState({ submitting: true, submitMessage: "", submitError: "" });

    try {
      const response = await axios.post(`${apiHost}/api/auth/ResetForgottenPassword`, {
        Email: this.state.email,
        Token: this.state.token,
        NewPassword: this.state.newPassword,
      });

      this.setState({
        submitMessage: response.data || "Your password has been reset. You can now log in.",
        submitError: "",
        submitting: false,
        newPassword: "",
        confirmPassword: "",
      });
      localStorage.removeItem("assettrakLoginThrottleUntil");
    } catch (e) {
      const responseData = e.response && e.response.data;
      const message = typeof responseData === "string"
        ? responseData
        : responseData && responseData.message
          ? responseData.message
          : "This password reset link is invalid or expired.";

      this.setState({
        submitMessage: "",
        submitError: message,
        submitting: false,
      });
    }
  };

  render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>Reset Password</title>
        </Helmet>
        <LoginNavbar></LoginNavbar>

        <div className="loginPage">
          <video
            className="loginVideoBackground"
            autoPlay
            muted
            loop
            playsInline
            preload="metadata"
            aria-hidden="true"
          >
            <source src="/videos/login-background.webm" type="video/webm" />
            <source src="/videos/login-background.mp4" type="video/mp4" />
          </video>
          <div className="loginVideoOverlay"></div>
          <div className="loginWrapper">
            <div className="loginHeader">
              <img className="loginLogo" src={visionTrakLogo} alt="VisionTrak" />
              <h1>Choose password.</h1>
              <p>Enter a new password for your AssetTrak account.</p>
              {this.state.submitMessage && (
                <p className="success-msg">{this.state.submitMessage}</p>
              )}
              {this.state.submitError && (
                <p className="error-msg">{this.state.submitError}</p>
              )}
            </div>
            <div className="loginForm">
              <form className="form" onSubmit={this.handleSubmit}>
                <div className="loginInput">
                  <div className="loginInputLeft">
                    <label>New password</label>
                  </div>
                  <div className="loginInputRight">
                    <input
                      type="password"
                      value={this.state.newPassword}
                      onChange={this.handleNewPassword}
                      autoComplete="new-password"
                    />
                    <div className="error-msg">
                      {this.state.passwordError && (
                        <p>{this.state.passwordError}</p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="loginInput">
                  <div className="loginInputLeft">
                    <label>Confirm password</label>
                  </div>
                  <div className="loginInputRight">
                    <input
                      type="password"
                      value={this.state.confirmPassword}
                      onChange={this.handleConfirmPassword}
                      autoComplete="new-password"
                    />
                    <div className="error-msg">
                      {this.state.confirmPasswordError && (
                        <p>{this.state.confirmPasswordError}</p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="loginBtnContainer">
                  <div className="loginBtn">
                    <input
                      type="submit"
                      value={this.state.submitting ? "Resetting..." : "Reset password"}
                      disabled={this.state.submitting}
                    />
                  </div>
                </div>
                <div className="loginHelpLink">
                  <Link to="/login">Back to login</Link>
                </div>
              </form>
            </div>
            <div className="loginFooter">
              <p>&copy; {new Date().getFullYear()} - Vision Trak Rentals Pty Ltd </p>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ResetPassword;
